import { BlurhashCanvas } from 'src/Components/BlurhashCanvas';

import { Props } from './Blurhash.props';

const Blurhash = ({ blurhash, width, height }: Props) => {
  return (
    <div style={{ width, height }}>
      <BlurhashCanvas width={width} height={height} blurhash={blurhash} />
    </div>
  );
};

export default Blurhash;
